import React from 'react';
import SComponent from '@/components/common/scomponent';
import { Temas } from '@/app/constants/temas';
import { Context } from '@/app/annotation/Context';
import { ExemploCtx } from '@/app/context/ExemploContext';

@Context({
    exemploctx:ExemploCtx
})
class Exemplo extends SComponent{
    componentDidMount(){
        this.setTema(Temas.CLEAR)
    }
    render(){
        return <div></div>
    }
}
export default Exemplo;